const reducer = (state: any) => {
  return {
    ...state,
    waiting: true,
    loaded: false,
  };
};

export default reducer;
